import { t } from '@app/i18n';
import type { ResourceAgent } from './Resources.api';

/**
 * Regras de texto do detalhe do agente (T7, fase 2) que não são componente. Moram aqui pela mesma razão do
 * `resourceVocab.ts`: um arquivo de componente só exporta componentes (`react-refresh/only-export-components`).
 */

/**
 * A API do agente no gateway, como o protótipo do M2 a escreve (`prototipo-aim-cpj4-d6-borda.md`): `a2a/<caminho>`,
 * o caminho da API na policy global, sem barras. É composta do caminho do recurso, e não lida de `route.api`: esse
 * campo é o id da API no gateway (`agent-cobranca`), e o agente sem rota nem o tem.
 */
export function apiOf(agent: Pick<ResourceAgent, 'path'>): string {
  return `a2a/${agent.path}`;
}

/** O impacto de remover o agente, em contratos que ganham nova versão sem a delegação. */
export function removalText(name: string, contracts: number): string {
  if (contracts === 0) return t('resources.agent.remove.text.zero', { name });
  return t(contracts === 1 ? 'resources.agent.remove.text.one' : 'resources.agent.remove.text.other', {
    n: contracts,
    name,
  });
}

/**
 * Os códigos de leitura do card que o contrato declara (`ResourceAgent.card_error`), cada um com a sua chave do
 * catálogo — EN camelCase, porque o código é snake_case e a chave não pode ser (`keyShape.test.ts`).
 */
const CARD_ERROR_KEY: Record<string, string> = {
  card_unreachable: 'cardUnreachable',
  card_invalid: 'cardInvalid',
  card_version_not_accepted: 'cardVersionNotAccepted',
  card_no_jsonrpc_interface: 'cardNoJsonrpcInterface',
  card_gateway_not_serving: 'cardGatewayNotServing',
  // Leitura pelo gateway com mTLS (executor 0.2.37+): sem SVID para apresentar, ou o gateway o recusou.
  card_no_client_certificate: 'cardNoClientCertificate',
  card_forbidden: 'cardForbidden',
};

/** A frase de uma leitura do card que falhou; código desconhecido aparece cru, nunca some. */
export function cardErrorText(code: string): string {
  const key = CARD_ERROR_KEY[code];
  return key ? t(`resources.agent.card.error.${key}`) : t('resources.agent.card.error.unknown', { code });
}
